import { Checkbox as NextCheckbox } from '@nextui-org/react';
import styled from 'styled-components';

type CheckboxExtraProps = {
  $borderColor?: string;
  isRounded?: boolean;
};

const Checkbox = styled(NextCheckbox).attrs<CheckboxExtraProps>(({ theme, $borderColor, isRounded }) => ({
  size: 'sm',
  css: {
    '& .nextui-checkbox-container': {
      height: '$8',
      width: '$8',
      borderRadius: isRounded ? undefined : '0',
      '--nextui--checkboxColor': theme.colors.primary.c700,
      '--nextui--checkboxColorHover': theme.colors.primary.c800,
      '--nextui--checkboxBorderColor': $borderColor ?? theme.colors.neutrals.white,
    },

    '& .nextui-checkbox-text': {
      fontSize: '$md',
      lineHeight: '$sm2',
    },
  },
}))``;

export default Checkbox;
